import * as React from 'react'

function IconRoundedRectangleBlocked({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={142}
      viewBox="0 0 104 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter0_rounded)">
            <path
              d="M104 16.354v109.532h-.081c-5.2 0-10.087 2.225-13.721 5.945-5.96 6.092-20.816 10.414-38.2 10.414-17.38 0-32.24-4.317-38.2-10.414-3.635-3.715-8.522-5.94-13.722-5.94H0V16.354h.076c5.195 0 10.087-2.225 13.722-5.94C19.758 4.322 34.618 0 51.998 0c17.384 0 32.24 4.317 38.2 10.41 3.634 3.714 8.521 5.944 13.721 5.944H104z"
              fill="#A2A2A2"
            />
            <path
              d="M51.998 132.852c-17.543 0-28.623-4.643-31.486-7.57-3.21-3.284-7.005-5.712-11.118-7.181V24.144c4.113-1.468 7.903-3.897 11.118-7.18 2.863-2.928 13.947-7.57 31.486-7.57 17.538 0 28.623 4.642 31.486 7.57 3.214 3.283 7.009 5.712 11.123 7.18V118.1c-4.114 1.469-7.909 3.897-11.123 7.181-2.863 2.927-13.944 7.57-31.486 7.57z"
              fill="#A2A2A2"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
            <path
              d="M38.916 57.703l25.497 26.32M64.413 57.703l-25.497 26.32"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter0_rounded"
              x={0}
              y={0}
              width={104}
              height={142.245}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M103 17.04v107.425h-.079c-5.1 0-9.893 2.183-13.458 5.831-5.845 5.975-20.415 10.214-37.465 10.214-17.046 0-31.62-4.235-37.466-10.214-3.564-3.644-8.357-5.826-13.458-5.826H1V17.04h.074c5.096 0 9.894-2.183 13.458-5.826C20.377 5.239 34.952 1 51.998 1c17.05 0 31.62 4.234 37.465 10.21 3.565 3.643 8.358 5.83 13.458 5.83H103z"
            fill="#fff"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M51.998 131.297c-17.206 0-28.073-4.554-30.88-7.425-3.149-3.22-6.87-5.602-10.905-7.042V24.68c4.034-1.44 7.752-3.822 10.904-7.043 2.808-2.87 13.68-7.424 30.88-7.424 17.201 0 28.073 4.553 30.881 7.424 3.153 3.22 6.875 5.602 10.91 7.043v92.15c-4.035 1.44-7.757 3.822-10.91 7.042-2.808 2.871-13.675 7.425-30.88 7.425z"
            fill="#A2A2A2"
            stroke="#fff"
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M39.168 57.594l25.006 25.813M64.174 57.594L39.168 83.407"
            stroke="#fff"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRoundedRectangleBlocked
